import React, { useEffect } from 'react';
import { useGetUserInfoQuery, useGetBalanceQuery } from 'services';
import { InputText, Loading } from 'components';
import { Button, InputWraper, useForm } from 'modules';
import * as Yup from 'yup';
import toast from 'react-hot-toast';

import { PopupWraper } from '../../../components/popup';
import { UpdatePasswordSuccess, UpdatePasswordSuccessDefined } from './configs';
import { useUpdatePasswordMutation } from 'services/user/mutation/useUpdatePasswordMutation';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';

interface UpdatePasswordProps {
  userId: string;
  onClose: () => void;
  forceUpdateTable: () => void;
}
const UpdatePassword = ({
  userId,
  onClose,
  forceUpdateTable,
}: UpdatePasswordProps) => {
  const { mutateAsync, data, error } = useUpdatePasswordMutation();
  const { data: userInfo, isFetching: isFetchungUserInfo } =
    useGetUserInfoQuery({ userId });
  const { phoneNumber, fullName } = userInfo?.data || {
    phoneNumber: '',
    fullName: '',
  };

  const { handleSubmit, getInputProps } = useForm({
    structure: [
      {
        name: 'pinCode',
        label: '',
        validate: Yup.number()
          .required('Vui lòng mật khẩu')
          .typeError('Vui lòng nhập số')
          .test('len', 'Mật khẩu phải đúng 6 chữ số', (val) => {
            if (val === undefined || val === null) return false;
            return val.toString().length === 6;
          }),
      },
    ],
    onSubmit: async (values) => {
      const payload = {
        userId: userId,
        requestBody: {
          pinCode: values.pinCode,
        },
      };

      try {
        await mutateAsync(payload);
      } catch (error) {
        console.log('error', error);
      }
      forceUpdateTable();
      onClose();
    },
  });

  useEffect(() => {
    if (data) {
      const { statusCode } = data;

      const dataDefined =
        UpdatePasswordSuccessDefined[statusCode as UpdatePasswordSuccess];

      if (statusCode === 200) {
        toast.success(dataDefined?.message, { duration: 1500 });
      }
    }

    // if (error) {
    //   const { status } = error as Error;
    //   toast.error(AddPointErrorDefined[(status as AddPointError) || 500]?.message);
    // }
  }, [data, error]);

  if (isFetchungUserInfo) {
    return <Loading isLoading={isFetchungUserInfo} />;
  } else {
    return (
      <div className='wrap-pop-up-add-point'>
        <PopupWraper title='Cập nhật mật khẩu' onClose={onClose}>
          <div className='container-fluid add-points__user-info'>
            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Tài khoản</div>
              <div className='col-md-4 col-12'>
                {normalizedPhoneNumber(phoneNumber || '')}
              </div>
            </div>

            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Tên tài khoản</div>
              <div className='col-md-4 col-12'>{fullName}</div>
            </div>
          </div>

          <div className='container-fluid add-points__form-add-point'>
            <div className='row add-points__user-info--elemnet'>
              <div className='col-md-4 col-12'>Mật khẩu</div>
              <div className='col-md-4 col-12'>
                <InputWraper
                  inputProps={getInputProps('pinCode')}
                  renderInput={(props) => {
                    return <InputText {...props} placeholder='Nhập mật khẩu' />;
                  }}
                />
              </div>
            </div>
          </div>
          <div className='add-points__button-add-point'>
            <Button
              buttonType='success'
              onClick={handleSubmit}
              label={'Cập nhật'}
            />
            <Button
              label='Trở về'
              buttonType='grey'
              onClick={() => onClose()}
            />
          </div>
        </PopupWraper>
      </div>
    );
  }
};

export default UpdatePassword;
